import { BrokerUrlParams } from 'broker/broker-routes';

export const transferableWorkspaceQueryParams = [
  BrokerUrlParams.ACTIVE_TAB,
  BrokerUrlParams.SELECTED_EMAIL,
  BrokerUrlParams.SELECTED_FILE,
];
